export default "__VITE_ASSET__7ce00462__"